import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  UNITS,
  UNIT,
  ADD,
  UPDATE,
  REMOVE,
  UNITSTATICDATA,
  FINANCE,
  UPDATEFINANCEDATA,
  WHOCANCONFIRMSOR,
  PHASECHANGE,
  CLEARFINANCEDATA,
  GET,
  CONFIRM,
  EXPORT,
  GET_SOR_SR,
  GETSORPARTY,
  CLEAR_SOR_PARTY,
  CONFIRM_FSOR,
  VALIDATE_CONFIRM_FSOR,
  FREEZE,
  UPDATE_ALL_SORS_FROZEN_STATE
} from '@hobs/constants/sor';
import { actionCreator } from './utils/utils';

export function getSorUnits(sorId, filter = 'All') {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation/Units/${filter}`
    )
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNITS.REQUEST };
  }
  function success(response) {
    return { type: UNITS.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNITS.FAILURE, error };
  }
}

export function getSorFinanceData(sorId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`StatementOfRequirements/${sorId}/SendingNationInfo`)
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FINANCE.REQUEST };
  }
  function success(response) {
    return { type: FINANCE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: FINANCE.FAILURE, error };
  }
}

export function clearSorFinanceData() {
  return dispatch => {
    dispatch({ type: CLEARFINANCEDATA.SUCCESS });
  };
}

export function getSorFinanceDataForSubmit(sorId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationInfo/ForSubmit`
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: WHOCANCONFIRMSOR.REQUEST };
  }
  function success(response) {
    return { type: WHOCANCONFIRMSOR.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: WHOCANCONFIRMSOR.FAILURE, error };
  }
}

export function updateSorFinanceData(sorId, sorFinanceData) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      `StatementOfRequirements/${sorId}/SaveSendingNationInfo`,
      { body: sorFinanceData, method: 'POST' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATEFINANCEDATA.REQUEST };
  }
  function success(response) {
    return { type: UPDATEFINANCEDATA.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UPDATEFINANCEDATA.FAILURE, error };
  }
}

export function getSorUnit(sorId, unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation/${unitId}`
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNIT.REQUEST };
  }
  function success(response) {
    return { type: UNIT.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNIT.FAILURE, error };
  }
}

export function resetSorUnit() {
  return {
    type: UNIT.RESET
  };
}

export function addElementToExercise(sorId, unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation`,
      { body: { unitId }, method: 'POST' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: ADD.REQUEST };
  }
  function success(response) {
    return { type: ADD.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: ADD.FAILURE, error };
  }
}

export function updateUnit(sorId, body) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation`,
      { body: body, method: 'PUT' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: UPDATE.REQUEST };
  }
  function success(response) {
    return { type: UPDATE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function getUnitStaticData(sorId, unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation/${unitId}/ForSubmit`
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: UNITSTATICDATA.REQUEST };
  }
  function success(response) {
    return { type: UNITSTATICDATA.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: UNITSTATICDATA.FAILURE, error };
  }
}

export function removeUnit(sorId, unitId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/SendingNationUnitInformation`,
      { body: { unitId }, method: 'DELETE' }
    )
      .then(response => {
        if (
          response &&
          response.status === 200 &&
          response.payload.isRemoved === true
        ) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
  function request() {
    return { type: REMOVE.REQUEST };
  }
  function success(response) {
    return { type: REMOVE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: REMOVE.FAILURE, error };
  }
}

export function changePhase(sorId, phaseName) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/ChangePhase/${phaseName}`,
      { method: 'POST' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: PHASECHANGE.REQUEST };
  }
  function success(response) {
    return { type: PHASECHANGE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: PHASECHANGE.FAILURE, error };
  }
}

export function freeze(sorId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/${sorId}/Freeze`,
      { method: 'POST' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FREEZE.REQUEST };
  }
  function success(response) {
    return { type: FREEZE.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: FREEZE.FAILURE, error };
  }
}

export const updateAllSorsFrozenState = isFrozen =>
  actionCreator(`StatementOfRequirements/Frozen`, UPDATE_ALL_SORS_FROZEN_STATE, {
    method: 'PATCH',
    body: isFrozen
  });

export function getSor(sorId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`StatementOfRequirements/${sorId}`)
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function confirmSor(sorId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`StatementOfRequirements/${sorId}/ConfirmIsor`, {
      method: 'POST'
    })
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success());
          return { success: true };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CONFIRM.REQUEST };
  }
  function success() {
    return { type: CONFIRM.SUCCESS };
  }
  function failure(error) {
    return { type: CONFIRM.FAILURE, error };
  }
}

export function exportSorOverview() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('StatementOfRequirements/Export', { forceBlob: true })
      .then(response => {
        if (response) {
          dispatch(success());
          return { success: true, payload: response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORT.REQUEST };
  }
  function success() {
    return { type: EXPORT.SUCCESS };
  }
  function failure(error) {
    return { type: EXPORT.FAILURE, error };
  }
}

export function getSorServiceRequest(partyId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`StatementOfRequirements/Party/${partyId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET_SOR_SR.REQUEST };
  }

  function success(item) {
    return { type: GET_SOR_SR.SUCCESS, item };
  }
  function failure(error) {
    return { type: GET_SOR_SR.FAILURE, error };
  }
}

export function getSorParty(partyId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`StatementOfRequirements/Summary/${partyId}`)
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, data: response.payload };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GETSORPARTY.REQUEST };
  }
  function success(response) {
    return { type: GETSORPARTY.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: GETSORPARTY.FAILURE, error };
  }
}

export function crealSorParty() {
  return dispatch => {
    dispatch({ type: CLEAR_SOR_PARTY.SUCCESS });
  };
}

export const confirmFsor = sorId =>
  actionCreator(`StatementOfRequirements/${sorId}/ConfirmFsor`, CONFIRM_FSOR, {
    method: 'POST'
  });

export const validateConfirmFsor = sorId =>
  actionCreator(`StatementOfRequirements/${sorId}/ValidateConfirmFsor`, VALIDATE_CONFIRM_FSOR, {
    method: 'POST'
  });
